
import { Component, Prop, Vue } from 'bits/vue'
import ImageThumbnail from 'library/v4/components/ImageThumbnail.vue'
import OzBaseButton from 'library/v4/components/OzBaseButton.vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzPlainButton, {
  OzPlainButtonColorScheme,
  OzPlainButtonSizePreset,
} from 'library/v4/components/OzPlainButton.vue'
import RelativeTime from 'library/v4/components/relative-time.vue'
import type { Wall as WallSnakeCase, WallCamelCase as Wall } from 'types'

const MIN_CARD_WIDTH = 190

@Component({ components: { OzIcon, OzBaseButton, OzPlainButton, ImageThumbnail, RelativeTime } })
export default class OzWallCard extends Vue {
  OzPlainButtonColorScheme = OzPlainButtonColorScheme
  OzPlainButtonSizePreset = OzPlainButtonSizePreset

  @Prop({ required: true, default: MIN_CARD_WIDTH }) cardWidth!: number
  @Prop({ required: true, default: [] }) wall!: Wall | WallSnakeCase
  @Prop({ default: 'updatedAt' }) wallTimestampType!: string
  @Prop({ default: true }) xMoreButton!: boolean
  @Prop({ default: false }) isTablet!: boolean

  isFocused = false

  handleMoreClick(event: PointerEvent): void {
    this.$emit('more', this.wall, event)
  }

  get wallLinkLabel(): string {
    return this.__('Go to %{wallTitle} padlet', { wallTitle: this.wallTitle })
  }

  get wallThumbnailTitle(): string {
    return this.__('%{wallTitle} padlet thumbnail', { wallTitle: this.wallTitle })
  }

  get wallTitle(): string {
    return this.wall.title || this.__('Untitled padlet')
  }

  get wallTimestamp(): string {
    if (this.wallTimestampType === 'updatedAt') {
      return 'updated_at' in this.wall ? this.wall.updated_at : this.wall.updatedAt
    }
    return this.wall[this.wallTimestampType]
  }
}
